/**
 * /tag/:tag — Performer tag pages
 * SEO target: high-volume fetish tags: /tag/feet, /tag/roleplay, /tag/bdsm, etc.
 * Uses performer-tags API (crowd-sourced) + falls back to category apiParams mapping.
 */
import React, { useState, useEffect, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Box, Typography, Grid, Button, Chip, Avatar, Skeleton,
} from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import axios from "axios";
import { PreRollAd } from "../components/TwinredPreRoll";

// ─── SEO head helper ─────────────────────────────────────────────────────────
const SEOHead = ({ title, description, keywords, canonical }) => {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content, prop = false) => {
      const selector = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        prop ? el.setAttribute("property", name) : el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    if (description) { setMeta("description", description); setMeta("og:description", description, true); }
    if (keywords) setMeta("keywords", keywords);
    if (title) setMeta("og:title", title, true);
    if (canonical) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
      link.href = canonical;
      setMeta("og:url", canonical, true);
    }
  }, [title, description, keywords, canonical]);
  return null;
};

// ─── Tag configuration ────────────────────────────────────────────────────────
// Maps URL tag slug → API params + SEO metadata
export const TAG_CONFIG = {
  feet: {
    label: "Feet",
    emoji: "🦶",
    h1: "Cam Girls with Feet Tag — Live Now",
    description: "Live cam girls tagged with feet fetish. These performers love foot shows — soles, arches, nylon, oil, and custom foot sessions. Browse free, go private anytime.",
    metaDescription: "Cam girls tagged #feet live now. Foot fetish performers streaming free. Soles, arches, toe shows and private foot sessions.",
    keywords: "feet cam girls, foot fetish cam, #feet cam, cam girls feet tag, foot cam live",
    apiParams: { fetish: "feet" },
    relatedTags: ["roleplay", "submissive", "voyeur"],
    relatedCategories: ["feet-cam-girls", "submissive-cam-girls", "voyeur-cam-girls"],
    gradient: "linear-gradient(135deg,#fddb92,#d1fdff)",
  },
  roleplay: {
    label: "Roleplay",
    emoji: "🎭",
    h1: "Roleplay Cam Girls — Live Fantasies Now",
    description: "Cam girls who love roleplay tagged live right now. Teacher, nurse, secretary, step-fantasy, custom scenarios — these performers bring your imagination to life.",
    metaDescription: "Roleplay cam girls live now. Fantasy scenarios — teacher, nurse, custom. Tag: #roleplay. Browse free or go private.",
    keywords: "roleplay cam girls tag, fantasy cam, roleplay live cam, cam girls roleplay tag, webcam roleplay",
    apiParams: { fetish: "roleplay" },
    relatedTags: ["bdsm", "dominant", "submissive"],
    relatedCategories: ["roleplay-cam-girls", "dominant-cam-girls", "milf-cam-girls"],
    gradient: "linear-gradient(135deg,#e0c3fc,#8ec5fc)",
  },
  bdsm: {
    label: "BDSM",
    emoji: "⛓️",
    h1: "BDSM Cam Girls — Live Kink Now",
    description: "BDSM-tagged cam girls streaming live. From bondage and discipline to femdom, spanking, and power exchange — explore kink in real time with experienced performers.",
    metaDescription: "BDSM cam girls tagged live now. Bondage, femdom, spanking, discipline. Tag: #bdsm. Browse free, book private.",
    keywords: "bdsm cam girls tag, bondage cam, femdom live cam, kink cam girls, bdsm webcam tag",
    apiParams: { fetish: "bdsm" },
    relatedTags: ["dominant", "submissive", "roleplay"],
    relatedCategories: ["bdsm-cam-girls", "dominant-cam-girls", "submissive-cam-girls"],
    gradient: "linear-gradient(135deg,#2c3e50,#fd746c)",
  },
  dominant: {
    label: "Dominant",
    emoji: "👠",
    h1: "Dominant Cam Girls — Live Femdom",
    description: "Dominant-tagged cam girls taking control in real time. Mistresses, Dommes, and femdom performers ready to command, humiliate, edge, and own your session.",
    metaDescription: "Dominant cam girls tagged live. Femdom, humiliation, orgasm control. Tag: #dominant. Go private to surrender.",
    keywords: "dominant cam girls tag, femdom cam tag, mistress live cam, domme webcam, dominant cam live",
    apiParams: { fetish: "dominant" },
    relatedTags: ["bdsm", "roleplay", "submissive"],
    relatedCategories: ["dominant-cam-girls", "bdsm-cam-girls", "mature-cam-girls"],
    gradient: "linear-gradient(135deg,#1a1a2e,#e94560)",
  },
  submissive: {
    label: "Submissive",
    emoji: "🎀",
    h1: "Submissive Cam Girls — Live Now",
    description: "Submissive-tagged cam girls who love being directed. Give the orders — these performers follow your lead, wear what you choose, and perform on command.",
    metaDescription: "Submissive cam girls tagged live. Obedient models who follow your instructions. Tag: #submissive. Browse free.",
    keywords: "submissive cam girls tag, obedient cam, sub cam tag, submissive webcam live, cam girls sub",
    apiParams: { fetish: "submissive" },
    relatedTags: ["dominant", "bdsm", "feet"],
    relatedCategories: ["submissive-cam-girls", "bdsm-cam-girls", "teen-cam-girls"],
    gradient: "linear-gradient(135deg,#ffecd2,#fcb69f)",
  },
  squirt: {
    label: "Squirt",
    emoji: "💦",
    h1: "Squirt Cam Girls — Wet Shows Live",
    description: "Squirt-tagged cam girls known for explosive wet performances. Real squirt shows in free chat or tip-goal unlocks. Go private for a guaranteed performance.",
    metaDescription: "Squirt cam girls tagged live. Real wet shows from verified squirt performers. Tag: #squirt. Watch free or go private.",
    keywords: "squirt cam girls tag, squirting cam live, wet cam show tag, squirt webcam, squirt performer tag",
    apiParams: { fetish: "squirt" },
    relatedTags: ["voyeur", "interactivetoy"],
    relatedCategories: ["squirt-cam-girls", "interactivetoy-cam-girls", "latina-cam-girls"],
    gradient: "linear-gradient(135deg,#4facfe,#00f2fe)",
  },
  voyeur: {
    label: "Voyeur",
    emoji: "👁️",
    h1: "Voyeur Cam Girls — Watch Undetected",
    description: "Voyeur-tagged cam girls streaming for those who love to watch. Exhibitionist performers, spy-cam vibes, natural moments — browse anonymously, no pressure.",
    metaDescription: "Voyeur cam girls tagged live. Watch exhibitionist models stream free. Tag: #voyeur. Stay anonymous.",
    keywords: "voyeur cam girls tag, spy cam tag, exhibitionist cam, voyeur webcam live, watch cam girls tag",
    apiParams: { fetish: "voyeur" },
    relatedTags: ["feet", "submissive"],
    relatedCategories: ["voyeur-cam-girls", "feet-cam-girls", "interactivetoy-cam-girls"],
    gradient: "linear-gradient(135deg,#30cfd0,#330867)",
  },
  interactivetoy: {
    label: "Interactive Toy",
    emoji: "📳",
    h1: "Interactive Toy Cam Girls — Control Her Vibe",
    description: "Tip to buzz. Cam girls tagged with interactive toys — Lovense and OhMiBod vibrators controlled by your tips in real time. Watch the reaction live.",
    metaDescription: "Interactive toy cam girls tagged live. Control Lovense vibrators with tips. Tag: #interactivetoy. Watch free.",
    keywords: "interactive toy cam tag, lovense cam girls tag, tip controlled cam, interactive vibe tag, cam girls interactivetoy",
    apiParams: { fetish: "interactivevibe" },
    relatedTags: ["squirt", "roleplay"],
    relatedCategories: ["interactivetoy-cam-girls", "squirt-cam-girls", "latina-cam-girls"],
    gradient: "linear-gradient(135deg,#43e97b,#38f9d7)",
  },
};

// ─── Styled ──────────────────────────────────────────────────────────────────
const blink = keyframes`0%{opacity:0}50%{opacity:1}100%{opacity:0}`;
const LiveDot = styled("span")({
  height: 8, width: 8, backgroundColor: "#4CAF50",
  borderRadius: "50%", display: "inline-block", marginRight: 6,
  animation: `${blink} 1.5s ease-in-out infinite`,
});

const PerformerTile = styled(Box)({
  position: "relative", borderRadius: 12, overflow: "hidden",
  cursor: "pointer", backgroundColor: "#111",
  "&:hover .overlay": { opacity: 1 },
  "&:hover img": { transform: "scale(1.05)" },
});

const Overlay = styled(Box)({
  position: "absolute", inset: 0, opacity: 0, transition: "opacity 0.2s",
  background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 60%)",
  display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: 12,
});

// ─── Main component ───────────────────────────────────────────────────────────
const TagPage = () => {
  const { tag } = useParams();
  const normalizedTag = tag?.toLowerCase();
  const config = TAG_CONFIG[normalizedTag];

  const [performers, setPerformers] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [page, setPage]             = useState(1);
  const [hasMore, setHasMore]       = useState(true);
  const [preRollPending, setPreRollPending] = useState(null);

  const fetchPerformers = useCallback(async (pageNum = 1, append = false) => {
    if (!config) return;
    setLoading(true);
    try {
      const params = { ...config.apiParams, limit: 24, page: pageNum };
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/performers`, { params });
      const list = Array.isArray(res.data) ? res.data : [];
      if (list.length < 24) setHasMore(false);

      const mapped = list.map((p) => {
        const a = p["@attributes"] || {};
        const gallery = (() => {
          const raw = p?.Media?.PhotoGallery?.Pic;
          if (!raw) return [];
          return (Array.isArray(raw) ? raw : [raw])
            .map(pic => pic?.Full?.["@attributes"]?.Src || "").filter(Boolean);
        })();
        return {
          id: a.Id, name: a.Name, age: a.Age,
          ethnicity: a.Ethnicity, hairColor: a.HairColor,
          goldShow: !!(a.PerfFlag && (parseInt(a.PerfFlag) & 0x00100000)),
          thumb: p?.Media?.Pic?.Thumb?.["@attributes"]?.Src || "",
          full:  p?.Media?.Pic?.Full?.["@attributes"]?.Src  || "",
          gallery, about: p?.Descriptions?.About || "",
          chatRoomUrl: `https://instacamgirlslive.com/cam/${a.Name}/?smid=${a.Id}&AFNO=1-94033`,
        };
      });
      setPerformers(prev => append ? [...prev, ...mapped] : mapped);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [config]);

  useEffect(() => {
    setPerformers([]); setPage(1); setHasMore(true);
    fetchPerformers(1, false);
  }, [normalizedTag, fetchPerformers]);

  const loadMore = () => {
    const next = page + 1;
    setPage(next);
    fetchPerformers(next, true);
  };

  if (!config) {
    // Unknown tag — render a graceful fallback with SEO content instead of a soft 404
    const prettyTag = tag ? tag.charAt(0).toUpperCase() + tag.slice(1) : 'Model';
    return (
      <Box sx={{ minHeight: '60vh', maxWidth: 700, mx: 'auto', p: 4 }}>
        <SEOHead
          title={`${prettyTag} Cam Girls — Live Now | Instacamgirls`}
          description={`Browse live ${prettyTag.toLowerCase()} cam girls streaming now on InstaCamGirls. Free chat, private shows and more.`}
          keywords={`${tag} cam girls, live ${tag} cam, ${tag} webcam, instacamgirls`}
          canonical={`https://instacamgirls.com/tag/${tag}`}
        />
        <Button component={Link} to="/" startIcon={<ArrowBackIcon />}
          sx={{ color: '#FF4196', mb: 3 }}>Back to Home</Button>
        <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
          #{prettyTag} Cam Girls
        </Typography>
        <Typography sx={{ color: '#666', mb: 4 }}>
          Browse live cam girls tagged with <strong>#{tag}</strong>. New models go live every hour.
        </Typography>
        <Button
          component={Link} to={`/?search=${encodeURIComponent(tag)}`}
          variant="contained"
          sx={{ bgcolor: '#FF4196', color: '#fff', borderRadius: '50px', px: 3,
            '&:hover': { bgcolor: '#e0377e' } }}>
          Search #{prettyTag} Models
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#fafafa" }}>
      <SEOHead
        title={`#${config.label} Cam Girls — Live Now | Instacamgirls`}
        description={config.metaDescription}
        keywords={config.keywords}
        canonical={`https://instacamgirls.com/tag/${normalizedTag}`}
      />

      {preRollPending && (
        <PreRollAd onComplete={() => {
          const p = preRollPending;
          window.open(p.chatRoomUrl, "_blank");
          setPreRollPending(null);
        }} />
      )}

      {/* Header */}
      <Box sx={{
        background: config.gradient,
        px: { xs: 2, md: 6 }, py: { xs: 4, md: 5 }, color: "#fff",
      }}>
        <Button
          component={Link} to="/"
          startIcon={<ArrowBackIcon />}
          sx={{ mb: 2, color: "rgba(255,255,255,0.85)", "&:hover": { color: "#fff" } }}
        >
          All Categories
        </Button>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <LiveDot />
          <Typography variant="body2" sx={{ fontWeight: 700, opacity: 0.9 }}>LIVE NOW</Typography>
          <Chip
            label={`#${config.label}`}
            size="small"
            sx={{ bgcolor: "rgba(255,255,255,0.25)", color: "#fff", fontWeight: 800, border: "1px solid rgba(255,255,255,0.5)" }}
          />
          {performers.length > 0 && (
            <Chip
              label={`${performers.length}+ online`}
              size="small"
              sx={{ bgcolor: "rgba(255,255,255,0.2)", color: "#fff", fontWeight: 600, border: "1px solid rgba(255,255,255,0.4)" }}
            />
          )}
        </Box>

        <Typography variant="h3" sx={{ fontWeight: 900, mb: 1.5, lineHeight: 1.2 }}>
          {config.emoji} {config.h1}
        </Typography>
        <Typography variant="h6" sx={{ opacity: 0.92, maxWidth: 680, fontWeight: 400 }}>
          {config.description}
        </Typography>
      </Box>

      {/* Grid */}
      <Box sx={{ px: { xs: 1, md: 4 }, py: 3, maxWidth: 1400, mx: "auto" }}>
        <Grid container spacing={2}>
          {loading && performers.length === 0
            ? Array.from({ length: 12 }).map((_, i) => (
                <Grid item xs={6} sm={4} md={3} key={i}>
                  <Skeleton variant="rectangular" height={260} sx={{ borderRadius: 2 }} />
                </Grid>
              ))
            : performers.map((p) => (
                <Grid item xs={6} sm={4} md={3} key={p.id}>
                  <PerformerTile onClick={() => setPreRollPending(p)}>
                    <Box
                      component="img"
                      src={p.gallery[0] || p.full || p.thumb}
                      alt={`${p.name} #${config.label} cam girl live`}
                      sx={{ width: "100%", height: 260, objectFit: "cover",
                        transition: "transform 0.3s ease", display: "block" }}
                      onError={(e) => { e.target.src = p.thumb || p.full || ""; }}
                    />
                    <Box sx={{
                      position: "absolute", top: 8, left: 8,
                      bgcolor: "rgba(76,175,80,0.9)", borderRadius: "12px",
                      px: 1, py: 0.3, display: "flex", alignItems: "center", gap: 0.5,
                    }}>
                      <LiveDot style={{ marginRight: 2 }} />
                      <Typography sx={{ color: "#fff", fontSize: "0.7rem", fontWeight: 700 }}>LIVE</Typography>
                    </Box>
                    {/* Tag badge */}
                    <Box sx={{
                      position: "absolute", top: 8, right: 8,
                      bgcolor: "rgba(0,0,0,0.6)", borderRadius: "10px",
                      px: 1, py: 0.3,
                    }}>
                      <Typography sx={{ color: "#fff", fontSize: "0.65rem", fontWeight: 700 }}>
                        #{config.label}
                      </Typography>
                    </Box>
                    {p.goldShow && (
                      <Chip label="🥇 GOLD" size="small" sx={{
                        position: "absolute", top: 36, right: 8,
                        bgcolor: "#FFD700", color: "#000", fontWeight: 700, fontSize: "0.65rem", height: 20,
                      }} />
                    )}
                    <Overlay className="overlay">
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                        <Avatar src={p.thumb} sx={{ width: 28, height: 28 }} />
                        <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "0.9rem" }}>{p.name}</Typography>
                      </Box>
                      {p.age && (
                        <Typography sx={{ color: "#ddd", fontSize: "0.75rem", mb: 1 }}>
                          {p.age} yrs{p.ethnicity ? ` · ${p.ethnicity}` : ""}
                        </Typography>
                      )}
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Button size="small" variant="contained"
                          sx={{ background: "linear-gradient(45deg,#e91e63,#9c27b0)", borderRadius: "20px",
                            fontSize: "0.7rem", py: 0.5, px: 1.5 }}
                          onClick={(e) => { e.stopPropagation(); setPreRollPending(p); }}>
                          <LiveTvIcon sx={{ fontSize: 13, mr: 0.5 }} /> Watch
                        </Button>
                        <Button size="small" variant="contained"
                          sx={{ background: "linear-gradient(90deg,#7c3aed,#a855f7)", color: "#fff",
                            borderRadius: "20px", fontSize: "0.7rem", py: 0.5, px: 1.5,
                            "&:hover": { background: "linear-gradient(90deg,#6d28d9,#9333ea)" } }}
                          onClick={(e) => { e.stopPropagation(); window.open(p.chatRoomUrl, "_blank"); }}>
                          💬 Chat
                        </Button>
                      </Box>
                    </Overlay>
                  </PerformerTile>
                </Grid>
              ))}
        </Grid>

        {hasMore && !loading && performers.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <Button variant="contained"
              sx={{ background: "linear-gradient(45deg,#FF6B6B,#FF2BAA)", borderRadius: "50px", px: 5, py: 1.5, fontWeight: 700 }}
              onClick={loadMore}>
              Load More
            </Button>
          </Box>
        )}

        {/* Related tags */}
        {config.relatedTags?.length > 0 && (
          <Box sx={{ mt: 5, p: 3, bgcolor: "#fff", borderRadius: 2, border: "1px solid #eee" }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>Related Tags</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {config.relatedTags.map((t) => (
                <Chip
                  key={t} label={`#${t}`}
                  component={Link} to={`/tag/${t}`} clickable
                  sx={{ bgcolor: "#f0f0ff", color: "#5c35d0", border: "1px solid #a78bfa",
                    fontWeight: 700, "&:hover": { bgcolor: "#5c35d0", color: "#fff" } }}
                />
              ))}
            </Box>

            {/* Related categories */}
            {config.relatedCategories?.length > 0 && (
              <Box sx={{ mt: 3 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#666" }}>
                  Browse by Category
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {config.relatedCategories.map((slug) => (
                    <Chip
                      key={slug} label={slug.replace(/-cam-girls$/, "").replace(/-/g, " ")}
                      component={Link} to={`/category/${slug}`} clickable
                      sx={{ bgcolor: "#fff0f7", color: "#FF4196", border: "1px solid #FF4196",
                        fontWeight: 600, textTransform: "capitalize",
                        "&:hover": { bgcolor: "#FF4196", color: "#fff" } }}
                    />
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        )}

        {/* All tags */}
        <Box sx={{ mt: 3, p: 3, bgcolor: "#fff", borderRadius: 2, border: "1px solid #eee" }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>Browse All Tags</Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {Object.entries(TAG_CONFIG).filter(([t]) => t !== normalizedTag).map(([t, c]) => (
              <Chip
                key={t} label={`${c.emoji} #${c.label}`}
                component={Link} to={`/tag/${t}`} clickable
                sx={{ bgcolor: "#f5f5f5", color: "#333", fontWeight: 600,
                  "&:hover": { bgcolor: "#333", color: "#fff" } }}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TagPage;
